import { render, staticRenderFns } from "./DoorSensorListItem.vue?vue&type=template&id=b74b8530&scoped=true&"
import script from "./DoorSensorListItem.vue?vue&type=script&lang=ts&"
export * from "./DoorSensorListItem.vue?vue&type=script&lang=ts&"
import style0 from "./DoorSensorListItem.vue?vue&type=style&index=0&id=b74b8530&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74b8530",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VImg})
